import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class BlogPost extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/blog/post'
    super(store, path)
  }

  publish(id, model, showProgress) {
    return this._request({
      action: this._urlencode(id) + '/publish',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
